import React, { Fragment } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useSelector } from "react-redux";
import moment from "moment";
import StyledTypography from "../common/StyledTypography";
import PropTypes from "prop-types";

export default function UserSigninLoggerTableRow({
  row,
  handleClick,
  isItemSelected,
}) {
  const timezoneMins = useSelector(({ timezone }) => timezone);

  return (
    <Fragment>
      <TableRow
        hover
        onClick={(event) => handleClick(event, row.ticket_number)}
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={row.ticket_number}
        selected={isItemSelected}
        sx={{ cursor: "pointer" }}
      >
        <TableCell align="left">
          <StyledTypography variant="subtitle2">{row.name}</StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.device_id}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.device_model}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.device_platform}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.app_version}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">{row.lat}</StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">{row.lon}</StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.ip_address}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.screen_resolution}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.grahics_card}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.mac_address}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">{row.memory}</StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {row.system_language}
          </StyledTypography>
        </TableCell>
        <TableCell align="left">
          <StyledTypography variant="subtitle2">
            {moment
              .utc(row.login_time)
              .add(timezoneMins, "minutes")
              .format("YYYY-MM-DD HH:mm")}
          </StyledTypography>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
UserSigninLoggerTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
  isItemSelected: PropTypes.bool,
};
